module.exports = __webpack_public_path__ + "img/D01.243583c1.png";